import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { TabPanelProps, type TabPanelPropsInternalProps } from '../types';
import { getStylingProps } from './style';

const TabPanel = ({ id, children, ...props }: TabPanelProps) => {
  const { tabId, isSelected, isRendered, variant } = props as TabPanelPropsInternalProps;

  return isRendered ? (
    <Container
      role="tabpanel"
      id={id}
      aria-labelledby={tabId}
      aria-hidden={!isSelected ? 'true' : undefined}
      hidden={!isSelected}
      {...getStylingProps(variant)}
      {...props}
    >
      {children}
    </Container>
  ) : null;
};

TabPanel.displayName = 'TabPanel';
TabPanel.id = 'TabPanel';

export default TabPanel;
